// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabDocFlows-moduleRequestProfileTabDocFlows__whYfZ";
export { _1 as "RequestProfileTabDocFlows" }
